import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Input = ({ placeholder, value, changeHandler }) => {
  return (
    <input
      value={value}
      onChange={changeHandler}
      className="join_room_input"
      placeholder={placeholder}
    />
  );
};

const JoinRoomInputs = (props) => {
  const { roomIdValue, setRoomIdValue, nameValue, setNameValue, isRoomHost } =
    props;

  const { roomId } = useParams(); // Extract roomId from URL parameters
  const [userCounter, setUserCounter] = useState(1); // Counter for generating unique usernames

  useEffect(() => {
    if (roomId && !isRoomHost) {
      setRoomIdValue(roomId); // Set the roomId from URL into the input field
    }

    // Auto-generate a unique name
    if (!nameValue) {
      setNameValue(nameValue);
      setUserCounter(nameValue); // Increment counter
    }
  }, [roomId, setRoomIdValue, isRoomHost, nameValue, setNameValue, userCounter]);

  const handleRoomIdValueChange = (event) => {
    setRoomIdValue(event.target.value);
  };

  const handleNameValueChange = (event) => {
    setNameValue(event.target.value);
  };

  return (
    <div className="join_room_inputs_container">
      {!isRoomHost && (
        <Input
          placeholder="Enter meeting ID"
          value={roomIdValue}
          changeHandler={handleRoomIdValueChange}
        />
      )}
      <Input
        placeholder="Enter your Name"
        value={nameValue}
        changeHandler={handleNameValueChange}
      />
    </div>
  );
};

export default JoinRoomInputs;
